//localhost
const Config = {
    BACKEND_URL : process.env.REACT_APP_BACKEND_URL,
    key: process.env.REACT_APP_KEY,
    iv: process.env.REACT_APP_IV,
    // Parse ENABLE_SSE as boolean - only true if explicitly set to 'true' (case-insensitive)
    // Defaults to false if not set or set to anything other than 'true'
    ENABLE_SSE: process.env.REACT_APP_ENABLE_SSE?.toLowerCase()?.trim() === 'true',
};
export default Config;
  